import { render, staticRenderFns } from "./GuideMsg.vue?vue&type=template&id=0aad3e28&scoped=true"
import script from "./GuideMsg.vue?vue&type=script&lang=js"
export * from "./GuideMsg.vue?vue&type=script&lang=js"
import style0 from "./GuideMsg.vue?vue&type=style&index=0&id=0aad3e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad3e28",
  null
  
)

export default component.exports